import React from 'react'

const PermanentSvg = (props) => {
    return (
    <svg  width={props.width} height={props.height} viewBox="0 0 44 59" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>{props.alt}</title>
        <path fillRule="evenodd" clipRule="evenodd" d="M7.81346 3.76173H36.7626L40.3813 32.8341H43.9999L40.3813 0.127686H4.19482L0.576172 32.8341H4.19482L7.81346 3.76173ZM33.144 21.9319H11.4321V25.566H33.144V21.9319ZM33.144 7.39577H11.4321V11.0298H33.144V7.39577ZM4.19482 58.2724H40.3813L43.9999 36.4681H0.576172L4.19482 58.2724ZM15.0507 40.1022H29.5253V43.7362H15.0507V40.1022ZM33.144 14.6639H11.4321V18.2979H33.144V14.6639ZM11.4321 32.8341H33.144V29.2H11.4321V32.8341Z" fill="#3A3A3A"/>
    </svg>
    )
}

export default PermanentSvg


